import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'province',
    name: 'province',
    component: Form,
    redirect: { name: 'province-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'province-list',
        component: () => import('@/views/province/ProvinceList.vue'),
        meta: {
          header: {
            label: () => i18n.t('title.list', [i18n.tc('province.label', 2)]),
          },
        },
      },
      {
        path: 'create',
        name: 'province-create',
        component: () => import('@/views/province/ProvinceCreate.vue'),
        meta: {
          header: {
            route: { name: 'province-list' },
            label: () => i18n.t('title.create', [i18n.tc('province.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id',
        name: 'province-edit',
        component: () => import('@/views/province/ProvinceEdit.vue'),
        meta: {
          header: {
            route: { name: 'province-list' },
            label: () => i18n.t('title.edit', [i18n.tc('province.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
